
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Link, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatDate } from '@/components/dashboard/products/utils/formatters';

interface VideoContentProps {
  title: string;
  publishedAt?: string;
  videoId?: string;
  onOpenVideo: () => void;
  onOpenProductDialog: () => void;
  isLoading: boolean;
  linkedProduct?: { id: string; name: string } | null;
}

const VideoContent: React.FC<VideoContentProps> = ({
  title,
  publishedAt,
  videoId,
  onOpenVideo,
  onOpenProductDialog,
  isLoading,
  linkedProduct,
}) => {
  return (
    <CardContent className="p-4">
      <h3 className="font-medium text-base mt-1 mb-2 dark:text-gray-200">{title}</h3>
      
      <div className="flex items-center justify-between text-xs text-gray-600 dark:text-gray-400 mt-3">
        <span>{formatDate(publishedAt || new Date().toISOString())}</span>
        
        <div className="flex gap-2">
          <button 
            className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 flex items-center"
            onClick={onOpenVideo}
          >
            <ExternalLink className="h-4 w-4 mr-1" />
            <span>Voir sur YouTube</span>
          </button>
        </div>
      </div>
      
      {/* Link to Product section */}
      <div className="mt-4 pt-3 border-t dark:border-gray-700/50">
        {linkedProduct ? (
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700 dark:text-gray-300">
              Lié au produit: <strong className="dark:text-gray-200">{linkedProduct.name}</strong>
            </span>
            <Button 
              variant="outline" 
              size="sm"
              onClick={onOpenProductDialog}
              disabled={isLoading}
              className="dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
            >
              <Link className="h-4 w-4 mr-1" />
              Changer
            </Button>
          </div>
        ) : (
          <Button 
            variant="outline" 
            size="sm" 
            className="w-full dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
            onClick={onOpenProductDialog}
            disabled={isLoading}
          >
            <Link className="h-4 w-4 mr-1" />
            Lier à un produit
          </Button>
        )}
      </div>
    </CardContent>
  );
};

export default VideoContent;
